// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__mACUO","rootNoMargin":"styles_rootNoMargin__1UVuc"};